<template>
    <!--    갤러리 편집 레이아웃<br>-->
    <ul class="gallery_edit_ul">
        <li class="list_item" v-for="gallery in galleryData" :key="`gallery${gallery.ci_idx}`" >
            <div class="thumbnail">
                <div class="thumbnail" :style="`background-image: url(${returnThumbnail(gallery)})`" @click="moveItemDetail(gallery)"></div>
                <div class="card_category cc_category" @click="moveItemDetail(gallery)">{{ returnItem(gallery).ic_name_eng }}</div>
                <div class="hash_delete" @click="openDeleteConfirm(gallery)"></div>
            </div>
            <div class="card_detail" @click="moveItemDetail(gallery)">
                <div class="card_title">{{ returnItem(gallery).i_name }}</div>
            </div>
        </li>
    </ul>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import imageResizeMixins from "@/mixins/imageResizeMixins";

export default {
    name: "GalleryListEditLayout",
    mixins: [imageOption, alertMixins, imageResizeMixins],
    components: {
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {
        galleryData: {default: () => []},
    },
    data() {
        return{
            idx: 1,
            galleryItemLists: 12,

        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        openModal(name){
            this.$modal.show(name, {galleryType: 'galleryUpdate'});
        },
        moveDetail(data){
            this.$router.push(`/gallery/edit/${data}`)
        },
        movePage(url) {
            this.$router.push(url);
        },
        returnItem(gallery) {
            return util.isEmpty(gallery) || util.isEmpty(gallery.Item) ? {} : gallery.Item;
        },
        returnThumbnail(data) {
            let item = this.returnItem(data);
            if (!util.isEmpty(item.ItemFile) && !util.isEmpty(item.ItemFile.Item)) {
                // return `${item.ItemFile.Item[0].org_url}?${this.setImageOptions(278, null, null)}`;
                // return `${item.ItemFile.Item[0].org_url}`;
                return this.setFitWidthImg(item.ItemFile.Item, 278);
            }
        },
        openDeleteConfirm(gallery) {
            /*this.createConfirm({
                content: `'<span class="subject">${item.i_name}</span>'<br>${this.$t('collection_item_add_confirm1')}`,
                confirm: () => {
                    console.log('test')
                    EventBus.$emit('writeGallery')
                },
                // content: `'<span class="subject">${this.itemname}</span>'<br>${this.$t('collection_item_add_confirm1')}`
            })*/
            let item = this.returnItem(gallery);
            let itemName = "";
            if(!util.isEmpty(item.i_name)) {
                itemName = item.i_name;
            }
            this.createConfirm({
                content: `'<span class="subject">${itemName}</span>'<br>${this.$t('collection_item_delete_confirm1')}`,
                confirm: () => {
                    EventBus.$emit('galleryListDelete', gallery.ci_idx);
                }
            })
        },
        moveItemDetail(gallery) {
            let itemData = this.returnItem(gallery);
            console.log(itemData)
            let url = `/item/${itemData.i_sku}`
            if(itemData.im_status === 2 || itemData.im_status === 5) {
                url = `/premiummarket/${itemData.i_sku}`
            }else if(itemData.im_status === 1 || itemData.im_status === 3 || itemData.im_status === 4) {
                url = `/openmarket/${itemData.i_sku}`
            }
            this.$router.push(url);
        },
        onClick(event) {
            console.log(event)
            if (util.isEmpty(event.target)) {
                return false;
            }
            let element = event.target;
            let elementSrc = element.currentSrc.split('?');

            if (util.isEmpty(elementSrc[0])) {
                return false;
            }
            this.changeThumnail(elementSrc[0]);
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
